"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PlayerState_1 = __importDefault(require("./constants/PlayerState"));

exports.playerStateChange = function (playerState, controller) {
  return function (state) {
    return {
      playerState: playerState,
      url: controller ? controller.getUrl() : '',
      // Force position to ending when receiving ENDED, because
      // we might not get another position update
      position: playerState !== PlayerState_1["default"].ENDED ? state.position : state.duration
    };
  };
};

exports.positionUpdate = function (positionObject) {
  return function (state) {
    var duration = state.streamInfo && state.streamInfo.liveNow ? state.streamInfo.duration : positionObject.duration;
    var position = positionObject.position;

    if (position === state.position && duration === state.duration) {
      return null;
    }

    return {
      position: position,
      duration: duration
    };
  };
};

exports.videoBitrateChange = function (videoBitrate) {
  return function (state) {
    return {
      videoBitrate: videoBitrate
    };
  };
};

exports.audioBitrateChange = function (audioBitrate) {
  return function (state) {
    return {
      audioBitrate: audioBitrate
    };
  };
};

exports.volumeChange = function (volume, controller) {
  return function (state) {
    return {
      volume: volume,
      muted: controller ? controller.isMute() : false
    };
  };
};

exports.resetState = function () {
  return function (state) {
    return {
      playerState: PlayerState_1["default"].STOPPED,
      position: 0,
      duration: 0,
      uiPosition: null,
      loaderVisible: false,
      streamInfo: null,
      playQueued: false,
      autoPlayWasBlocked: false
    };
  };
};

exports.autoPlayWasBlocked = function () {
  return {
    autoPlayWasBlocked: true
  };
};